import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const faqs = [
  {
    question: 'What payment methods do you accept?',
    answer: 'We accept credit, debit, Apple Pay, Android Pay, and cash.',
  },
  {
    question: 'Do you offer same-day service?',
    answer: 'Yes, we offer same-day pick-up and delivery for Wash and Fold services.',
  },
];

const FAQ: React.FC = () => {
  return (
    <Box sx={{ p: 4, backgroundColor: 'background.default' }}>
      <Typography variant="h4" align="center" sx={{ mb: 4 }}>
        Frequentely Asked Question
      </Typography>
      {faqs.map((faq, index) => (
        <Accordion key={index}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>{faq.question}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>{faq.answer}</Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default FAQ;
